import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import WidgetContext from 'components/widget-context'
import HighYieldTile from '../../high-yield-tiles'
import { getEstimatedSavings, highYieldSavingsData, validDepositAmount, getApy } from '../lenders-data'

const HYSLendersList = ({ lenders, balanceAmount, pageFrom, pageTo }) => {
  const value = useContext(WidgetContext),
    sortAndSlice = (data) => data.sort((a, b) => getApy(
      b.slug,
      b.slugVertical,
      lenders,
      validDepositAmount(b.minimumBalance, balanceAmount),
    )[0] - getApy(
      a.slug,
      a.slugVertical,
      lenders,
      validDepositAmount(a.minimumBalance, balanceAmount),
    )[0])
      .slice(pageFrom, pageTo)
  return (
    <div>
      {!!lenders.length
          && sortAndSlice(highYieldSavingsData)
            .map((lender, index) => {
              const {
                  slug,
                  fees,
                  name,
                  ctaUrl,
                  minimumBalance,
                  slugVertical,
                  fdicInsured,
                } = lender,
                validDeposit = validDepositAmount(minimumBalance, balanceAmount),
                [apy, vertical] = getApy(slug, slugVertical, lenders, validDeposit)

              return (
                <HighYieldTile
                  key={`${vertical}-${slug}`}
                  slug={slug}
                  fees={fees}
                  name={name}
                  vertical={vertical}
                  ctaUrl={ctaUrl}
                  minimumBalance={minimumBalance}
                  fdicInsured={fdicInsured}
                  balanceAmount={balanceAmount}
                  WidgetContext={value}
                  apy={apy}
                  estimatedSavings={`$${getEstimatedSavings(apy, balanceAmount)}`}
                  displayOrder={index + 1}
                />
              )
            })}
    </div>
  )
}
HYSLendersList.propTypes = {
  lenders: PropTypes.array,
  pageFrom: PropTypes.number,
  pageTo: PropTypes.number,
  balanceAmount: PropTypes.number,
}

export { HYSLendersList }

export default HYSLendersList
